var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwoPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75 6C5.88909 6 6.8125 5.07659 6.8125 3.9375C6.8125 2.79841 5.88909 1.875 4.75 1.875C3.61091 1.875 2.6875 2.79841 2.6875 3.9375C2.6875 5.07659 3.61091 6 4.75 6Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.375 10.125C1.375 8.26104 2.88604 6.75 4.75 6.75C6.61396 6.75 8.125 8.26104 8.125 10.125",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.12556 2.2081C8.98821 1.64758 10.132 1.80847 10.8066 2.58523C11.4811 3.36198 11.4801 4.51705 10.8042 5.29263C10.1283 6.06821 8.98424 6.22712 8.12256 5.6651",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 6.83353C9.50122 6.6067 10.5513 6.84741 11.3537 7.48771C12.1562 8.12801 12.6239 9.09844 12.625 10.125",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoPeople);
export default __webpack_public_path__ + "static/media/two-people.2fce6caa1a6d4cec02f903cf9a911050.svg";
export { ForwardRef as ReactComponent };